<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <v-tour
    :name="name"
    :steps="steps"
    :options="resolvedOptions"
    :callbacks="callbacks"
    @targetNotFound="$emit('target-not-found', $event)"
  >
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :finish="tour.finish"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :enabled-buttons="tour.enabledButtons"
          :highlight="tour.highlight"
          :stop-on-fail="resolvedOptions.stopOnTargetNotFound"
          :debug="tour.debug"
          @targetNotFound="$emit('target-not-found', $event)"
        >
          <div
            slot="content"
            class="v-step__content"
          >
            <div v-html="tour.steps[tour.currentStep].content" />
            <small class="d-block mt-75 text-muted">
              {{
                $t("tutorials.common.stepProgress", {
                  current: tour.currentStep + 1,
                  total: tour.steps.length,
                })
              }}
            </small>
          </div>

          <div
            slot="actions"
            class="tour-actions d-flex flex-wrap justify-content-between"
          >
            <b-button
              v-if="
                tour.currentStep != tour.steps.length - 1 &&
                  isButtonEnabled(tour, 'buttonSkip')
              "
              size="sm"
              variant="outline-primary"
              class="btn-tour-skip mr-1"
              @click="tour.skip"
            >
              <span class="mr-25 align-middle">{{ tour.labels.buttonSkip }}</span>
              <feather-icon
                icon="XIcon"
                size="12"
              />
            </b-button>

            <!-- Previous Button -->
            <b-button
              v-if="tour.currentStep && isButtonEnabled(tour, 'buttonPrevious')"
              size="sm"
              variant="outline-primary mr-1"
              @click="tour.previousStep"
            >
              <feather-icon
                icon="ChevronLeftIcon"
                size="12"
              />
              <span class="ml-25 align-middle">
                {{ tour.labels.buttonPrevious }}
              </span>
            </b-button>

            <!-- Next Button -->
            <b-button
              v-if="
                tour.currentStep != tour.steps.length - 1 &&
                  isButtonEnabled(tour, 'buttonNext')
              "
              size="sm"
              variant="primary"
              class="btn-tour-next"
              @click="tour.nextStep"
            >
              <span class="mr-25 align-middle">{{ tour.labels.buttonNext }}</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="12"
              />
            </b-button>

            <!-- Finish Button -->
            <b-button
              v-if="
                tour.currentStep == tour.steps.length - 1 &&
                  isButtonEnabled(tour, 'buttonStop')
              "
              size="sm"
              variant="primary"
              class="btn-tour-finish"
              @click="tour.finish"
            >
              <span class="mr-25 align-middle">{{ tour.labels.buttonStop }}</span>
              <feather-icon
                icon="CheckCircleIcon"
                size="12"
              />
            </b-button>
          </div>

        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'AppTour',
  components: {
    BButton,
  },
  props: {
    name: {
      type: String,
      default: 'vuexyTour',
    },
    steps: {
      required: true,
      type: Array,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    callbacks: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    resolvedOptions() {
      return {
        ...this.options,
        labels: {
          buttonSkip: this.$t('tutorials.common.skip'),
          buttonPrevious: this.$t('tutorials.common.previous'),
          buttonNext: this.$t('tutorials.common.next'),
          buttonStop: this.$t('tutorials.common.finish'),
          ...(this.options.labels || {}),
        },
      }
    },
  },
  methods: {
    isButtonEnabled(tour, button) {
      return (
        !Object.prototype.hasOwnProperty.call(tour.enabledButtons, button) ||
        tour.enabledButtons[button]
      )
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/tour.scss';
</style>
